module.exports = __webpack_public_path__ + "assets/img/techang.40295133.png";